<div class="wrap">
  <h1>Budget vs Spend Heatmap <span class="sub">— by Cost Head</span></h1>
  <app-loading *ngIf="isLoading"></app-loading>

  <!-- Main Table Panel -->
  <div *ngIf="!isLoading">
    <div class="grid-wrap" *ngIf="costHeads?.length; else noRecord">
      <div class="grid">
        <table>
          <thead>
            <tr>
              <th class="diagonal"><span>{{ displayLabels?.project | titlecase }}</span><span>Cost Head</span></th>
              <th *ngFor="let head of costHeads" style="background-color: #b0b0ae; color: #111">{{ head }}</th>
              <th style="background-color: #b0b0ae; color: #111">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of projects">
              <td class="wrap-two-lines row-title" [title]="p.name">{{ p.name }}</td>

              <td *ngFor="let head of costHeads">
                <ng-container *ngIf="p.values[head] as val">
                  <div class="cell interactive-cell"
                    [style.background]="color(utilization(val.spend, val.budget))"
                    [matMenuTriggerFor]="heatmapMenu"
                    [matMenuTriggerData]="{ project: p, head: head, val: val }">
                    <div class="meta">
                      <b>{{ utilization(val.spend, val.budget) * 100 | appFormat: "float" }}%</b>
                    </div>
                    <div class="meta muted">
                      {{ fmtShort(val.spend) }} / {{ fmtShort(val.budget) }}
                    </div>
                  </div>
                </ng-container>
              </td>

              <!-- Total Column -->
              <td>
                <div class="cell interactive-cell"
                  [style.background]="color(utilization(getTotalSpend(p), getTotalBudget(p)))"
                  [matMenuTriggerFor]="heatmapMenu"
                  [matMenuTriggerData]="getMenuTriggerData(p)">
                  <div class="meta">
                    <b>{{ utilization(getTotalSpend(p), getTotalBudget(p)) * 100 | appFormat: "float" }}%</b>
                  </div>
                  <div class="meta muted">
                    {{ fmtShort(getTotalSpend(p)) }} / {{ fmtShort(getTotalBudget(p)) }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- THE MENU (Styled to look like the Tooltip) -->
  <mat-menu #heatmapMenu="matMenu" class="custom-tooltip-menu">
    <ng-template matMenuContent let-p="project" let-head="head" let-val="val">
      <!-- Using your exact original class name here -->
      <div class="custom-tooltip-container" (click)="$event.stopPropagation()">
        
        <div class="tooltip-header">
          <h4>{{ p.name }}</h4>
          <p class="cost-head">{{ head }}</p>
        </div>

        <div class="tooltip-body">
          <div class="budget-info">
            <div class="budget-item">
              <span class="label">Total Budget</span>
              <span class="value">{{ "" | currencySymbol }}{{ fmtShort(val.budget) }}</span>
            </div>
            <div class="budget-item">
              <span class="label">POs Raised</span>
              <span class="value">{{ "" | currencySymbol }}{{ fmtShort(val.intendedSpend || 0) }}</span>
            </div>
            <div class="budget-item">
              <span class="label">Total Spend</span>
              <span class="value">{{ "" | currencySymbol }}{{ fmtShort(val.spend) }}</span>
            </div>
          </div>

          <div class="ougdp-section" *ngIf="val.ougdpData?.length">
            <h5>OU/GDP Distribution</h5>
            <div class="chart-container">
              <div class="vendor-list">
                <div *ngFor="let vendor of val.ougdpData; let i = index" class="vendor-item">
                  <div class="vendor-info">
                    <span class="vendor-name">{{ vendor.vendor_name }}</span>
                    <span class="vendor-amount">{{ "" | currencySymbol }}{{ fmtShort(vendor.spend_amount) }}</span>
                    <span class="vendor-percentage">
                      ({{ getVendorPercentage(vendor, val.spend) | appFormat: (getVendorPercentage(vendor, val.spend) === 100 ? "int" : "float") }}%)
                    </span>
                  </div>
                  <div class="vendor-bar">
                    <div class="bar-fill" 
                      [style.width.%]="getVendorPercentage(vendor, val.spend)" 
                      [style.background-color]="getVendorColor(i)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="no-ougdp" *ngIf="!val.ougdpData?.length">
            <p class="muted">No OU/GDP distribution data available</p>
          </div>
        </div>
      </div>
    </ng-template>
  </mat-menu>
</div>